import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { roleGuard } from './shared/guards/role.guard';
import {contestantGuard} from './shared/guards/contestant.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(r => r.authRoutes),
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then(r => r.adminRoutes),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'contestant',
    loadChildren: () => import('./contestant/contestant.routes').then(r => r.contestantRoutes),
    canActivate: [authGuard, roleGuard, contestantGuard],
  },
  {
    path: 'jury',
    loadChildren: () => import('./jury/jury.routes').then(r => r.juryRoutes),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  }
];
